import { Modal } from "antd";
import PropTypes from "prop-types";
import "./PdfViewerModal.css";

import { PdfViewer } from "../pdf-viewer/PdfViewer";

function PdfViewerModal({ open, setOpen }) {
  return (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      maskClosable={false}
      centered
      footer={null}
      width={1000}
    >
      <div className="pdf-viewer-modal">
        <PdfViewer />
      </div>
    </Modal>
  );
}

PdfViewerModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export { PdfViewerModal };
